import React, { useEffect, useRef } from 'react';

export default function CompoundTraceCanvas({ points, signature }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !points?.length) return undefined;

    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    let frame;

    const draw = (progress = 1) => {
      const bounds = canvas.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(bounds.width * ratio);
      canvas.height = Math.round(bounds.height * ratio);

      const context = canvas.getContext('2d');
      const styles = getComputedStyle(canvas);
      const visible = Math.max(2, Math.ceil(points.length * progress));
      context.scale(ratio, ratio);
      context.clearRect(0, 0, bounds.width, bounds.height);
      context.beginPath();
      points.slice(0, visible).forEach((point, index) => {
        const x = ((point.x - 8) / 344) * bounds.width;
        const y = ((point.y - 8) / 130) * bounds.height;
        if (index === 0) context.moveTo(x, y);
        else context.lineTo(x, y);
      });
      context.strokeStyle = styles.getPropertyValue('--specimen-trace').trim() || '#0d6758';
      context.lineWidth = Math.max(2, bounds.width / 145);
      context.lineCap = 'round';
      context.lineJoin = 'round';
      context.stroke();
    };

    if (media.matches) {
      draw();
    } else {
      const started = performance.now();
      const animate = now => {
        const progress = Math.min(1, (now - started) / 950);
        draw(1 - ((1 - progress) ** 3));
        if (progress < 1) frame = requestAnimationFrame(animate);
      };
      frame = requestAnimationFrame(animate);
    }

    const observer = typeof ResizeObserver === 'function'
      ? new ResizeObserver(() => draw())
      : null;
    observer?.observe(canvas);

    return () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
    };
  }, [points, signature]);

  return (
    <canvas
      ref={canvasRef}
      className="product-specimen__trace"
      data-signature={signature}
      aria-hidden="true"
    />
  );
}
